module.exports = __webpack_public_path__ + "static/img/warning_modal_icon.6c0a6448.svg";